<div class="k-overlay" *ngIf="isOpened"></div>
<kendo-dialog *ngIf="isOpened" [minWidth]="350" [title]="title" (close)="close()">
    <form class="k-form" #form="ngForm" (ngSubmit)="save()">
        <fieldset>
            <kendo-gridlayout [cols]="[300]" [gap]="5">
                <kendo-gridlayout-item [col]="1" [row]="1">
                    <kendo-formfield>
                        <kendo-label>{{ 'cf-signature.dialog.signWithPin.column.pin' | translate }}:</kendo-label>
                        <input name="pin" kendoTextBox type="text" #pin="ngModel" [(ngModel)]="pinCode" required pattern="\d{4}" />
                        <kendo-formerror *ngIf="pin.errors?.['required']" textContent="{{ 'input.required.error' | translate }}">
                        </kendo-formerror>
                        <kendo-formerror
                            *ngIf="pin.errors?.['pattern']"
                            textContent="{{ 'cf-signature.dialog.signWithPinPatternRequired' | translate }}">
                        </kendo-formerror>
                    </kendo-formfield>
                </kendo-gridlayout-item>
            </kendo-gridlayout>
        </fieldset>

        <div class="k-actions k-actions-end">
            <button kendoButton type="submit" themeColor="success">
                <i class="fas fa-save"></i>
                {{ 'labels.sign' | translate }}
            </button>
            <button kendoButton type="button" icon="close" themeColor="dark" (click)="close()">
                {{ 'labels.cancel' | translate }}
            </button>
        </div>
    </form>
</kendo-dialog>
